import { privacyOptions } from 'utils/constants/settings-constants'
import _ from "lodash";
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'

const HelperEmployeePrivacy = {
	
	isSameTeam: ( employee1, employee2 ) => {
		return _.get( employee1, [ 'team', 'guid' ], '---1' ) === _.get( employee2, [ 'team', 'guid' ], '---2' );
	},
	
	validatePrivacy: ( employee, field, isFavourite ) => {
		const _employee = store.getState().data[ dataConstants.EMPLOYEE ];
		
		switch( true ) {
			case _.get( employee, field, privacyOptions.TEAM ) === privacyOptions.TEAM:
				return ( isFavourite || HelperEmployeePrivacy.isSameTeam( _employee, employee ) );
			
			case _.get( employee, field, privacyOptions.TEAM ) === privacyOptions.NO:
				return false;
		}
		
		return true;
	},
	
	canFavourite: ( employee, isFavourite ) => {
		return HelperEmployeePrivacy.validatePrivacy( employee, 'show_favourite', isFavourite );
	},
	
	canShowPhoneNumber: ( employee, isFavourite ) => {
		return HelperEmployeePrivacy.validatePrivacy( employee, 'show_phonenumber', isFavourite );
	},
	
	canShowCalendar: ( employee, isFavourite ) => {
		return HelperEmployeePrivacy.validatePrivacy( employee, 'show_calendar', isFavourite );
	},
}

export default HelperEmployeePrivacy
